import Warning from '@assets/icons/warning.svg'
import { Icon } from './Icon'

export const WarningIcon = Icon(Warning)
